// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"738c852e","455":"8ca03a32","977":"5ed28b7d"}[chunkId] + ".chunk.js";
};